<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';

const props = defineProps({
  attribute: {
    type: Object,
    required: true,
  },
  isEditingView: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update', 'delete']);
const { t } = useI18n();

const attributeValue = ref(Boolean(props.attribute.value));

const handleChange = value => {
  emit('update', value);
};
</script>

<template>
  <div
    class="flex items-center w-full gap-2"
    :class="{
      'justify-start': isEditingView,
      'justify-end': !isEditingView,
    }"
  >
    <Switch
      v-model="attributeValue"
      :aria-label="attribute.attributeDisplayName"
      @change="handleChange"
    />
    <Button
      v-if="isEditingView"
      variant="faded"
      color="ruby"
      icon="i-lucide-trash"
      size="xs"
      :aria-label="
        t('CONTACTS_LAYOUT.SIDEBAR.ATTRIBUTES.ACTIONS.DELETE', {
          name: attribute.attributeDisplayName,
        })
      "
      class="flex-shrink-0 !h-11 !w-11 hover:no-underline"
      @click="emit('delete')"
    />
  </div>
</template>
